import {
  CalendarResponse,
  MeetingDetail,
  MeetingOverview,
  ParamsGetCalendar,
  PayloadAcceptMeeting,
  PayloadCancelMeeting,
  PayloadCreateMeeting
} from '@/models/MeetingScheduler';
import axios from '@/plugins/axios';

export async function getCalendar(month: string): Promise<CalendarResponse> {
  const params: ParamsGetCalendar = {
    month,
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone
  };
  return (await axios.get('/v1/meetings/calendar', { params })).data;
}

export async function createMeeting(payload: PayloadCreateMeeting): Promise<MeetingDetail> {
  return (await axios.post('/v1/meetings', payload)).data;
}

export async function getMeetingDetail(meetingId: string): Promise<MeetingDetail> {
  return (await axios.get(`/v1/meetings/${meetingId}`)).data;
}

export async function acceptMeeting(meetingId: string, payload: PayloadAcceptMeeting): Promise<MeetingDetail> {
  return (await axios.post(`/v1/meetings/${meetingId}/accept`, payload)).data;
}

export async function cancelMeeting(meetingId: string, payload?: PayloadCancelMeeting): Promise<void> {
  await axios.post(`/v1/meetings/${meetingId}/cancel`, payload);
}

export async function markMeetingRead(meetingId: string): Promise<void> {
  await axios.post(`/v1/meetings/${meetingId}/read`);
}

export async function searchMeetings(q: string): Promise<MeetingOverview[]> {
  return (await axios.get('/v1/meetings/search', { params: { q } })).data;
}
